import React from 'react';
import NewProjectButton from '../NewProjectButtons/NewProjectButton';

const ImportProjectButton = (props) => <NewProjectButton {...props} create={false} />
export default ImportProjectButton;



// WEBPACK FOOTER //
// ./src/components/buttons/ImportProjectButton/index.js